// extracted by mini-css-extract-plugin
module.exports = {"wrapText":"plex-dictionary_wrap-text__2jsuc"};